import { type DataType, type IInfoGroup } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type InfoGroupsResult } from './types';

export const GET_ALL_INFO_GROUPS = 'getAllInfoGroups';
export const GET_INFO_GROUP_BY_TYPE = 'getInfoGroupByType';
export const GET_INFO_GROUPS_BY_CLASS_NAME = 'getInfoGroupsByClassName';

export const getters: GetterTree<InfoGroupsResult, unknown> = {
    [GET_ALL_INFO_GROUPS]: (_state): IInfoGroup[] | undefined => {
        return Array.from(_state.allInfoGroups.values());
    },
    [GET_INFO_GROUPS_BY_CLASS_NAME]: (_state) => {
        return (forClassName: DataType): IInfoGroup[] => {
            return (
                Array.from(_state.allInfoGroups.values()).filter((infoGroup: IInfoGroup) => {
                    return infoGroup.forClassName === forClassName;
                }) ?? []
            );
        };
    },
    [GET_INFO_GROUP_BY_TYPE]: (_state) => {
        return (infoGroupType: string): IInfoGroup | undefined => {
            return _state.allInfoGroups.get(infoGroupType);
        };
    }
};
